import { MenuListProps, components } from 'react-select'
import * as React from 'react'
import { SelectOption } from '../select.types'

export const MenuList = (props: MenuListProps<SelectOption>) => (
  <components.MenuList {...props} className="py-0 max-h-[300px]" />
)
